export const CARUSO_HELP_CENTER =
	"https://help.getcaruso.com/en/collections/3853095-the-investor-portal";
export const CARUSO_MARKETING_SITE = "https://www.getcaruso.com";
export const CARUSO_BLOG_INVESTOR_GUIDE =
	"https://www.getcaruso.com/resources/blog/who-is-caruso-investor-guide";
